import VueRouter, { Location, Route } from 'vue-router';
import { isTalkJoy } from '@/appApi';

interface RouteRedirect {
	path: string | string[];
	target: string;
	query?: (to: Route) => NonNullable<Location['query']>;
	origin?: (to: Route) => string | undefined;
}

export const routeRedirects: RouteRedirect[] = [
	{
		path: ['/ibook/:id', '/ibook'],
		target: '/pages/ibook/index',
		origin: (to) => to.query.talk === '1' ? process.env.VUE_APP_TALK : process.env.VUE_APP_HOST,
		query: (to) => {
			const hasQueryId = Object.prototype.hasOwnProperty.call(to.query, 'id');

			return {
				...to.query,
				id: hasQueryId ? to.query.id : to.params.id,
				...(hasQueryId ? { buy: '1' } : {}),
			};
		},
	},
	{
		path: '/booksThemeList',
		target: '/pages/booksThemeList/index',
		origin: (to) => isTalkJoy() ? process.env.VUE_APP_TALK : process.env.VUE_APP_HOST,
		query: (to) => ({
			...to.query,
		}),
	}
];

export function getRouteRedirect(router: VueRouter, to: Route): string | null {
	const redirect = routeRedirects.find(({ path }) => (
		to.matched.some(route => (Array.isArray(path) ? path.includes(route.path) : path === route.path))
	));

	if (!redirect) {
		return null;
	}

	const target = redirect.target.replace(/:([^/]+)/g, (placeholder, paramName: string) => {
		const param = to.params[paramName];
		return param === undefined ? placeholder : encodeURIComponent(param);
	});

	const location: Location = {
		path: target,
		query: redirect.query ? redirect.query(to) : to.query,
		hash: to.hash,
	};
	const href = router.resolve(location).href;
	const origin = redirect.origin && redirect.origin(to);

	return origin ? `${origin.replace(/\/+$/, '')}${href}` : href;
}
